// components/AuthControls.jsx
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import alertify from '../lib/alertifySetup';
import { useAuth } from '../context/AuthContext';
import { useLang } from '../i18n';

export default function AuthControls({ onNavigate = () => {} }) {
  const { user, profile, loading, loggingIn, login, logout } = useAuth();
  const { t, to } = useLang();
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleOutside);
    document.addEventListener('touchstart', handleOutside);
    return () => {
      document.removeEventListener('mousedown', handleOutside);
      document.removeEventListener('touchstart', handleOutside);
    };
  }, []);

  if (loading) {
    return <span className="small text-muted px-2">{t('auth.loading')}</span>;
  }

  if (!user) {
    return (
      <button
        type="button"
        className="btn btn-ink btn-sm ms-lg-2"
        disabled={loggingIn}
        onClick={async () => {
          try {
            await login();
          } catch (err) {
            console.error('Giriş başarısız:', err);
            alertify.error(t('auth.loginFail', { err: err.code || err.message || '?' }));
          }
        }}
      >
        {loggingIn ? t('auth.loggingIn') : t('auth.login')}
      </button>
    );
  }

  const name = profile?.nickname || user.displayName || t('auth.player');
  const streak = profile?.streak || 1;

  return (
    <div className="d-flex align-items-center gap-2 ms-lg-2" ref={wrapperRef}>
      <span
        className="tag medium"
        title={t('auth.streakTitle', { n: streak })}
      >
        🔥 {t('auth.streakDays', { n: streak })}
      </span>

      <div className="position-relative">
        <button
          type="button"
          className="btn btn-soft btn-sm d-flex align-items-center gap-2"
          onClick={() => setOpen((o) => !o)}
          aria-expanded={open}
        >
          {user.photoURL && (
            <img
              src={user.photoURL}
              alt=""
              width={22}
              height={22}
              className="rounded-circle"
              referrerPolicy="no-referrer"
            />
          )}
          <span className="text-truncate" style={{ maxWidth: 120 }}>{name}</span>
        </button>

        {open && (
          <div className="dropdown-menu dropdown-menu-end show mt-1" style={{ position: 'absolute', right: 0, left: 'auto', zIndex: 1050 }}>
            <Link className="dropdown-item" to={to('profile')} onClick={() => { setOpen(false); onNavigate(); }}>
              {t('auth.profile')}
            </Link>
            <button
              type="button"
              className="dropdown-item"
              onClick={() => { setOpen(false); onNavigate(); logout(); }}
            >
              {t('auth.logout')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
